<div class="container" role="main">
    <div class="HmsContainer">
        <div class="row">
            <div class="row HmsInsideContainer">
                <div class="col-md-12 button-padding-left">
                    <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to
                        Previous Section</button>
                    <button type="button" class="greyBtn ml-5" *ngIf="isInstruction" (click)="openInstruction()"
                        style="font-weight : bold;">Instructions</button>
                    <button type="submit" class="orangeBtn ml-5" (click)="participantDetailsSubmit()"
                        *ngIf="isFormsValid" [ngStyle]="{'background-color': primaryColor}">Proceed to Next Section</button>
                </div>
            </div>
            <div class="row HmsInsideContainer py-0">
                <div class="col-md-12 button-padding-left">
                    <p role="heading" aria-level="1">Please enter information regarding the {{title}}</p>
                </div>
            </div>
        </div>
        <div class="row HmsInsideContainer" *ngIf="isformloaded">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="col-md-10">
                    <form class="participantForm" [formGroup]="participantForm">
                        <app-json-form [controlsData]="participantFormData1.controls" [formData]="participantForm"
                            (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </form>
                    <form class="participantForm" [formGroup]="participantForm2">
                        <app-json-form [controlsData]="participantFormData2.controls" [formData]="participantForm2"
                            (valueChangeEvent)="valueChangeEvent($event)"  [customClass]="'width50p'"></app-json-form>
                    </form>
                    <form class="participantForm" [formGroup]="participantForm3">
                        <app-json-form [controlsData]="participantFormData3.controls" [formData]="participantForm3"
                            (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>

                            <button type="submit" class="orangeBtn ml-5" (click)="participantDetailsSubmit()"
                            *ngIf="isFormsValid" [ngStyle]="{'background-color': primaryColor}">Proceed to Next Section</button>
                    </form>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="col-md-10">
                    <form class="participantForm" [formGroup]="participantForm4">
                        <app-json-form [controlsData]="participantFormData4.controls" [formData]="participantForm4"
                            (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>